"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const EnvironmentHelper_1 = require("../../helpers/EnvironmentHelper");
const LoggerHelper_1 = require("../../helpers/LoggerHelper");
class ALauncher extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            launchUrl: this._getLauncherUrl(),
        };
    }
    componentWillMount() {
        LoggerHelper_1.logger.action({ name: this._getLoggerAction() });
    }
    componentDidMount() {
        if (EnvironmentHelper_1.deviceType !== EnvironmentHelper_1.DeviceTypes.Desktop) {
            window.location.href = this.state.launchUrl;
        }
    }
    render() {
        return React.createElement("iframe", { id: 'skypeLauncher', style: { display: 'none' }, src: this.state.launchUrl });
    }
}
exports.ALauncher = ALauncher;
